import {
  IconPhoto,
  IconHandClick,
  IconDownload,
  IconShare,
  IconPhotoCheck,
  IconAddressBook,
  IconShoppingCart,
  IconDeviceMobileDown,
} from '@tabler/icons-react'
import { type Icon } from '@tabler/icons-react'

export type GalleryNavItemType = 'action' | 'expandable'

export interface GalleryNavItem {
  id: string
  label: string
  icon: Icon
  type: GalleryNavItemType
}

export const galleryNavItems: GalleryNavItem[] = [
  { id: 'albums', label: 'Alben', icon: IconPhoto, type: 'expandable' },
  { id: 'select', label: 'Auswählen', icon: IconHandClick, type: 'action' },
  { id: 'download', label: 'Herunterladen', icon: IconDownload, type: 'action' },
  { id: 'share', label: 'Teilen', icon: IconShare, type: 'action' },
  { id: 'imageSelection', label: 'Bilderauswahl', icon: IconPhotoCheck, type: 'action' },
  { id: 'contact', label: 'Kontakt', icon: IconAddressBook, type: 'action' },
  { id: 'shop', label: 'Shop', icon: IconShoppingCart, type: 'action' },
  // Only rendered where the device can install at all — see shouldOfferAppInstall()
  { id: 'installApp', label: 'App installieren', icon: IconDeviceMobileDown, type: 'action' },
]
